import { useUIStore } from '@/stores'
import { Dashboard } from '@/components/views/Dashboard'
import { ThreadView } from '@/components/views/ThreadView'
import { ProjectExplorer } from '@/components/views/ProjectExplorer'
import { Settings } from '@/components/views/Settings'
import { WalletView } from '@/components/views/WalletView'
import { MarketplaceView } from '@/components/views/MarketplaceView'
import { AdminPanel } from '@/components/views/AdminPanel'
import { ApiKeysView } from '@/components/views/ApiKeysView'
import { FileManagerView } from '@/components/views/FileManagerView'
import { AppBuilderView } from '@/components/views/AppBuilderView'
import { AgentView } from '@/components/views/AgentView'
import { SocialAgentView } from '@/components/views/SocialAgentView'
import { ContentSeoView } from '@/components/views/ContentSeoView'

export function MainContent() {
  const { activeView } = useUIStore()

  switch (activeView) {
    case 'thread': return <ThreadView />
    case 'project': return <ProjectExplorer />
    case 'settings': return <Settings />
    case 'wallet': return <WalletView />
    case 'marketplace': return <MarketplaceView />
    case 'admin': return <AdminPanel />
    case 'api-keys': return <ApiKeysView />
    case 'app-builder': return <AppBuilderView />
    case 'agent': return <AgentView />
    case 'social-agent': return <SocialAgentView />
    case 'content-seo': return <ContentSeoView />
    case 'files': return <FileManagerView />
    default: return <Dashboard />
  }
}
